export default "__VITE_ASSET__D8ES7ZS4__"